module.exports = __webpack_public_path__ + "img/ebi-and-sushi-toppings.ee447fb6.png";